var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('MessageList',{directives:[{name:"show",rawName:"v-show",value:(_vm.listView),expression:"listView"}],ref:"refreshList",attrs:{"scroll":_vm.corY},on:{"clicked":_vm.onClickChild,"newMessage":_vm.onClickChildNew,"editMessage":_vm.onClickChild}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }